export const getAllPractices = state => state.practices.allPractices;
export const getPracticesProcessing = state => state.practices.processing;
export const getViewedPractices = state => state.practices.viewedPractices;
